import { render, staticRenderFns } from "./UserLoginHistory.vue?vue&type=template&id=4ad052ad&scoped=true&"
import script from "./UserLoginHistory.vue?vue&type=script&lang=js&"
export * from "./UserLoginHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad052ad",
  null
  
)

export default component.exports